/**
 * Blog post registry. Add new posts here and create a corresponding file in posts/.
 * locationUrlName: used to build /appointment/locations?location=<name> for location-specific booking.
 */
import {
  BOOKING_FLOWS,
  BOOKING_SCREENS,
  withBookingAttributionQuery,
} from '../../utils/booking-attribution';
const postModules = {
  'best-massage-in-westport-ct': () =>
    import('./best-massage-in-westport-ct.js'),
  'best-massage-in-south-tampa-fl': () =>
    import('./best-massage-in-south-tampa-fl.js'),
  'massage-near-me-south-tampa-fl': () =>
    import('./massage-near-me-south-tampa-fl.js'),
  'best-massage-in-san-antonio-tx': () =>
    import('./best-massage-in-san-antonio-tx.js'),
  'best-massage-in-studio-city-ca': () =>
    import('./best-massage-in-studio-city-ca.js'),
  'best-massage-in-sarasota-fl': () =>
    import('./best-massage-in-sarasota-fl.js'),
  'massage-near-me-in-sarasota-fl': () =>
    import('./massage-near-me-in-sarasota-fl.js'),
  'best-massage-in-scottsdale-az': () =>
    import('./best-massage-in-scottsdale-az.js'),
  'massage-near-me-in-laguna-niguel-ca': () =>
    import('./massage-near-me-in-laguna-niguel-ca.js'),
  'best-massage-in-laguna-niguel-ca': () =>
    import('./best-massage-in-laguna-niguel-ca.js'),
  'massage-near-me-in-rogers-ar': () =>
    import('./massage-near-me-in-rogers-ar.js'),
  'massage-near-me-in-charlotte-nc': () =>
    import('./massage-near-me-in-charlotte-nc.js'),
  'massage-near-me-in-san-mateo': () =>
    import('./massage-near-me-in-san-mateo.js'),
  'best-massage-in-san-mateo-ca': () =>
    import('./best-massage-in-san-mateo-ca.js'),
  'best-massage-in-westlake-village-ca': () =>
    import('./best-massage-in-westlake-village-ca.js'),
  'best-massage-in-the-conejo-valley': () =>
    import('./best-massage-in-the-conejo-valley.js'),
  'best-massage-in-agoura-hills': () =>
    import('./best-massage-in-agoura-hills.js'),
  'best-massage-in-huntsville-al': () =>
    import('./best-massage-in-huntsville-al.js'),
  'best-massage-in-charlotte-nc': () =>
    import('./best-massage-in-charlotte-nc.js'),
};

/** Map blog slug -> location url_name (from API) for deep-linking Book A Massage to that location. */
const slugToLocationUrlName = {
  'best-massage-in-westport-ct': 'westport',
  'best-massage-in-south-tampa-fl': 'tampa',
  'massage-near-me-south-tampa-fl': 'tampa',
  'best-massage-in-san-antonio-tx': 'sanantonio',
  'best-massage-in-studio-city-ca': 'studiocity',
  'best-massage-in-sarasota-fl': 'sarasota',
  'massage-near-me-in-sarasota-fl': 'sarasota',
  'best-massage-in-scottsdale-az': 'scottsdale',
  'massage-near-me-in-laguna-niguel-ca': 'lagunaniguel',
  'best-massage-in-laguna-niguel-ca': 'lagunaniguel',
  'massage-near-me-in-rogers-ar': 'rogers',
  'massage-near-me-in-charlotte-nc': 'charlotte',
  'massage-near-me-in-san-mateo': 'sanmateo',
  'best-massage-in-san-mateo-ca': 'sanmateo',
  'best-massage-in-westlake-village-ca': 'westlake',
  'best-massage-in-the-conejo-valley': 'westlake',
  'best-massage-in-agoura-hills': 'westlake',
  'best-massage-in-huntsville-al': 'huntsville',
  'best-massage-in-charlotte-nc': 'charlotte',
};

export const postSlugs = Object.keys(postModules);

export function getPostBySlug(slug) {
  return postModules[slug] ? postModules[slug]() : null;
}

export function hasPost(slug) {
  return Boolean(postModules[slug]);
}

/** Returns location-specific book URL for blog CTA, or generic locations URL. */
export function getBookUrlForSlug(slug) {
  const locationUrlName = slugToLocationUrlName[slug];
  const bookUrl = locationUrlName
    ? `/appointment/locations?location=${locationUrlName}`
    : '/appointment/locations';
  return withBookingAttributionQuery(bookUrl, {
    flow: BOOKING_FLOWS.BROWSE,
    screen: BOOKING_SCREENS.BLOG_DEEP_LINK,
  });
}
